import { useEffect, useRef, useState } from "react";

const ListingMediaPreview = ({
  videoSrc,
  posterSrc,
  alt,
  className = "",
  fallbackSrc,
}) => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isVideoReady, setIsVideoReady] = useState(false);

  useEffect(() => {
    const node = containerRef.current;

    if (!node || !videoSrc) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const nextVisible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
        setIsVisible(nextVisible);
      },
      {
        rootMargin: "180px 0px",
        threshold: [0, 0.35, 0.75],
      }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [videoSrc]);

  useEffect(() => {
    if (!isVisible) {
      setIsVideoReady(false);
    }
  }, [isVisible]);

  const poster = posterSrc || fallbackSrc;

  return (
    <div ref={containerRef} className={`relative overflow-hidden ${className}`}>
      <img
        src={poster}
        alt={alt}
        loading="lazy"
        decoding="async"
        className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-200 ${
          isVisible && videoSrc && isVideoReady ? "opacity-0" : "opacity-100"
        }`}
      />

      {videoSrc && isVisible && (
        <video
          key={videoSrc}
          src={videoSrc}
          poster={poster}
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-200 ${
            isVideoReady ? "opacity-100" : "opacity-0"
          }`}
          muted
          loop
          autoPlay
          playsInline
          preload="none"
          onLoadedData={(e) => {
            setIsVideoReady(true);
            e.currentTarget.play().catch(() => {});
          }}
          onError={() => {
            setIsVideoReady(false);
          }}
        />
      )}
    </div>
  );
};

export default ListingMediaPreview;
